import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import SubNavigationItems, { SubNavigationItemProps } from "go-app/components/Navigation/SubNavigationItems";
import { PartnerActionTypes } from "../../../../../../../services/Api/Partner/partnerTypes";
import { selectPartner } from "../../../../../../../services/partner/selectors";
import { useUserPermissions } from "../../../hooks";
import { isPosnetPartner } from "../../../utils";

const PartnerNavigation = (props: RouteComponentProps) => {
	const { t } = useTranslation("admin");
	const dispatch = useDispatch();
	const partner = useSelector(selectPartner);
	const { hasBasicPermission, hasUsersPermission, hasMoneyFlowPermission } = useUserPermissions(
		partner?.current_user_permissions
	);
	const partnerId = partner?.id;
	const prefixUrl = `/partnership/${partnerId}`;
	const items: SubNavigationItemProps[] = [
		{
			title: t("lib:common.action.preview"),
			route: `${prefixUrl}`,
			isActiveRoute: () => {
				return (
					props.location.pathname.split("/").length < 4 ||
					props.location.pathname === `${props.match.url}/edit`
				);
			},
			hide: !hasBasicPermission,
		},
		{
			title: t("modules.organization.header.title"),
			route: `${prefixUrl}/organizations`,
			isActiveRoute: () => {
				return (
					props.location.pathname.includes("/organizations") &&
					!props.location.pathname.includes("/organizations/new")
				);
			},
			hide: !hasBasicPermission,
		},
		{
			title: t("common.word.partners"),
			route: `${prefixUrl}/partners`,
			hide: !partner?.any_sub_partner,
		},
		{
			title: t("modules.payoff.header.title"),
			route: `${prefixUrl}/payoff`,
			hide: !hasMoneyFlowPermission,
		},
		{
			title: t("modules.payout_invoice.header.title"),
			route: `${prefixUrl}/payout_invoices`,
			hide: !hasMoneyFlowPermission,
		},
		{
			title: t("modules.partner_report.header.title"),
			route: `${prefixUrl}/report`,
			hide: !hasMoneyFlowPermission,
		},
		{
			title: t("lib:common.word.users"),
			route: `${prefixUrl}/users`,
			hide: !hasUsersPermission,
		},
		{
			divider: true,
			title: "",
			route: "",
		},
		{
			title: t("modules.loan.header.title"),
			route: `${prefixUrl}/loans`,
			hide: !hasBasicPermission,
		},
		{
			title: t("modules.organization.header.new.title"),
			route: `${prefixUrl}/organizations/new`,
			hide: isPosnetPartner(partner?.parent),
		},
	];

	useEffect(() => {
		return () => {
			dispatch({
				type: PartnerActionTypes.CLEAR,
			});
		};
	}, []);

	return (
		<SubNavigationItems
			title={t("modules.partner.field.partner_panel.title")}
			subtitle={partner?.name}
			items={items}
		/>
	);
};

export default PartnerNavigation;
